import React from 'react';
import { Outlet } from 'react-router-dom';

function ChurchLayout() {
  return (
    <div className="church-layout">
      <Outlet />
    </div>
  );
}

export default ChurchLayout;
